import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles, ArrowUpRight } from "lucide-react";

// Onboarding: introduces Luma to a brand-new member on their dashboard. Softer than the doctrine — deliberately.
export const LumaWelcome = ({ firstName = "friend" }) => (
  <motion.div
    data-testid="luma-welcome"
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, ease: [0.65, 0, 0.35, 1] }}
    className="relative overflow-hidden rounded-2xl border border-[#F59E0B]/20 bg-[#FFFDF9] p-6 md:p-8 mb-12"
  >
    <div aria-hidden="true" className="pointer-events-none absolute -right-16 -top-16 w-64 h-64 rounded-full bg-[#F59E0B]/10 blur-3xl" />
    <div className="relative flex flex-col md:flex-row md:items-center gap-5 md:gap-7">
      <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#F59E0B]/40 to-[#B45309]/20 border border-[#F59E0B]/30 flex items-center justify-center shrink-0">
        <Sparkles size={22} className="text-[#B45309]" strokeWidth={1.5} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B45309] mb-2">§ Meet Luma</div>
        <h3 className="font-display text-2xl md:text-3xl tracking-tight mb-2">
          You're not doing this alone, <span className="italic text-[#B45309]">{firstName}</span>.
        </h3>
        <p className="text-[#78716C] text-sm leading-relaxed max-w-xl">
          Luma is a gentle companion — here anytime it gets heavy. Private, patient, no judgement. Tell her whatever's
          weighing on you and she'll meet you right where you are. A good first stop before Module 01.
        </p>
      </div>
      <Link
        to="/peer-plus#luma"
        data-testid="luma-welcome-cta"
        className="btn-ember text-sm shrink-0 self-start md:self-center whitespace-nowrap"
      >
        Say hello to Luma <ArrowUpRight size={16} />
      </Link>
    </div>
  </motion.div>
);
